import { ScreenBase } from "@frui.ts/screens";
import { interfaces } from "inversify";
import { action, computed, observable } from "mobx";
import LocalizationService from "services/localizationService";
import FuelType from "entities/fuelType";
import ChargeOrderFuelItem from "models/chargeOrderFuelItem";
import FuelTypeResponse from "entities/fuelTypeResponse";
import { getValidationMessage } from "@frui.ts/validation";

export default class FuelViewModel extends ScreenBase {
  @observable batchIndex: number | undefined;
  @observable fuelTypeItem = new FuelTypeResponse();
  @observable displayTooltip = false;

  constructor(
    public localizationService: LocalizationService,
    fuelTypeItem: FuelTypeResponse,
    public chargeOrderFuelItem: ChargeOrderFuelItem
  ) {
    super();
    this.fuelTypeItem = fuelTypeItem;
  }

  @computed
  get isCSLocale() {
    return this.localizationService.locale == "cs";
  }

  @computed
  get chargeFuelType() {
    return `${this.fuelTypeItem.fuelType}`;
  }

  @computed
  get error() {
    return getValidationMessage(this.chargeOrderFuelItem, "fuelTypeId");
  }

  @computed
  get isOtherType() {
    return this.fuelTypeItem.fuelType === FuelType.Other;
  }

  @computed
  get isTypeWithDescription() {
    return this.fuelTypeItem.fuelType === FuelType.NaturalGas || this.fuelTypeItem.fuelType === FuelType.PhevWithLimitedCo2;
  }

  @computed
  get isDisabledFuelType() {
    return (
      this.chargeOrderFuelItem._fuelTypeLimitation &&
      this.chargeOrderFuelItem._fuelTypeLimitation?.allowedFuelTypeId !== this.fuelTypeItem.id
    );
  }

  @action.bound
  translateAttribute(code: string) {
    return this.localizationService.translateAttribute("fuelType", code);
  }

  @action.bound
  showTooltip() {
    this.displayTooltip = true;
  }
  @action.bound
  closeTooltip() {
    this.displayTooltip = false;
  }

  static Factory({ container }: interfaces.Context) {
    return (fuelTypeItem: FuelTypeResponse, chargeOrderFuelItem: ChargeOrderFuelItem) => {
      return new FuelViewModel(container.get(LocalizationService), fuelTypeItem, chargeOrderFuelItem);
    };
  }
}
